import React from 'react';
import Loading from './components/Loading';
import Parameters from './components/Parameters';
import Prices from './components/Prices';
import CutoffTimeShipping from './components/CutoffTimeShipping';

const Fabrication = () => (
  <>
    <Loading />
    <div className="row g-0">
      <div className="col-lg-4 pcb-form-section-wrapper">
        <Parameters />
      </div>
      <div className="col-lg-8 pcb-price-section-wrapper">
        <Prices />
        <CutoffTimeShipping />
      </div>
    </div>
  </>
)

export default Fabrication;